/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EnumUserPermissionFromJSON, EnumUserPermissionToJSON } from './EnumUserPermission';
export function UpdateOrganizationUserRequestUserFromJSON(json) {
    return UpdateOrganizationUserRequestUserFromJSONTyped(json, false);
}
export function UpdateOrganizationUserRequestUserFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        permission: !exists(json, 'permission') ? undefined : EnumUserPermissionFromJSON(json['permission'])
    };
}
export function UpdateOrganizationUserRequestUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        permission: EnumUserPermissionToJSON(value.permission)
    };
}
